import { createControlField } from '@lib/common';
import { blue } from '@material-ui/core/colors';
import styled from 'styled-components';
import { FormControl, InputLabel, Select, FormHelperText } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';

const StatusAutoComplete = ({ value, onChange }) => {
  const form = useFormContext();

  return (
    <Styles>
      <FormControl variant="outlined" size="small" fullWidth>
        <InputLabel id="adult_flag_label">Adult Flag</InputLabel>
        <Select
          labelId="adult_content_label"
          id="adult"
          name="adult"
          inputRef={form.register}
          native
          label="Adult Content"
          defaultValue="Content Funding Status">
          <option value="0">No</option>
          <option value="1">Yes</option>
        </Select>
        <FormHelperText>Is this Adult Content?</FormHelperText>
      </FormControl>
    </Styles>
  );
};

const Styles = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;

export const AdultContentField = createControlField(StatusAutoComplete, []);
